<template>
    <b-list-group-item>
        <div class="d-flex justify-content-between info">
            <span class = "font-weight-semi-bold">{{ time }} {{ ticket.game | lang('titles') }}</span>
            <span v-if="!ticket.payed_out">{{ ticket.amount }}</span>
            <span v-else-if="ticket.status == 'won'" class="text-success">{{ ticket.payed_out }}</span>
            <span v-else class="text-danger">{{ ticket.payed_out }}</span>
        </div>
        <div class="d-flex flex-wrap symbols" :class="`symbols-${ticket.game}`">
            <span class="symbol"
                :class="[`color-${colorBySymbol(symbol)}`, isGuessed(symbol, index) ? 'active' : '']"
                v-for="(symbol, index) in ticket.symbols"
                :key="index">
                {{ symbol }}
            </span>
        </div>
    </b-list-group-item>
</template>

<script>
import moment from 'moment';

export default {
    props: ['ticket'],

    methods: {
        colorBySymbol(symbol) {
            const game = Object.values(Config.games).find(game => game.name == this.ticket.game);

            const item = Object.values(game.items).find(item => item.symbol == symbol);

            return item.color;
        },

        isGuessed(symbol, index) {
            if (!this.ticket.draw_symbols) {
                return false;
            }

            switch (this.ticket.game) {
                case 'Jokerjackpot':
                    return this.ticket.draw_symbols[index] == symbol;
                default:
                    return this.ticket.draw_symbols.includes(symbol);
            }
        },
    },
    computed: {
        time() {
            return moment(this.ticket.date).add(Config.timezone, 'hours').format('HH:mm:ss');
        }
    }
}
</script>